import React from 'react';

import classNames from 'classnames';

import {
    CheckIcon,
    Toast,
} from 'wanderu-components';

import warningTriangle from 'wanderu-assets/images/warning.svg';

import LiveCheckMessage from '../LiveCheckMessage/LiveCheckMessage';

import styles from './LiveCheckStatus.scss';

export interface LiveCheckData {
    error?: string[];
    notFound?: string[];
    outboundTripIds?: string[];
    prices?: {
        current?: object;
        previous?: object;
    };
    priceDown?: string[];
    priceUp?: string[];
    showLiveCheckMessage?: boolean;
    total?: number;
    unavailable?: string[];
}

interface LiveCheckStatusProps {
    isLowerPrice?: boolean;
    liveCheckData?: LiveCheckData;
    outboundTripIds?: string[];
    returnTripIds?: string[];
    useMobileStyling?: boolean;
}

const LiveCheckStatus: React.FC<LiveCheckStatusProps> = ({
    isLowerPrice = false,
    liveCheckData = {},
    outboundTripIds,
    returnTripIds,
    useMobileStyling = false,
}) => {
    const {
        showLiveCheckMessage,
    } = liveCheckData;

    if (!showLiveCheckMessage) {
        return null;
    }

    return (
        <Toast
            className={classNames(
                {
                    [styles.liveCheckStatusMobile]: useMobileStyling,
                    [styles.liveCheckStatusDesktop]: !useMobileStyling,
                    [styles.green]: isLowerPrice,
                },
            )}
            showInline
        >
            {isLowerPrice
                ? (
                    <CheckIcon
                        className={styles.checkIcon}
                        fontSize="small"
                    />
                )
                : (
                    <img
                        alt=""
                        className={styles.warningTriangle}
                        src={warningTriangle}
                    />
                )}

            <LiveCheckMessage
                {...liveCheckData}
                outboundTripIds={outboundTripIds}
                returnTripIds={returnTripIds}
            />
        </Toast>
    );
};

export default LiveCheckStatus;
